
// Hamburger Animation
$( ".hamburger" ).click(function() {
  $( this ).toggleClass( "is-active" );
});

$( ".js-nav-control" ).click(function() {
 	$('body').toggleClass('open');
});


// Smooth Scroll Animation
var scroll = new SmoothScroll('a[href*="#"]');

// SEARCH 

$('.user-icons').on("click", function(e) {
  $('#search-pop').hide();
});


$("body").on("click", '.js-show-search, .search-close', function(e) {
  $('.search-close').css('padding-top', $('.header').height() + 100 + 'px')
  if($('#search-pop').is(":visible") && $(window).scrollTop() == 0) {
    $(".index .header").removeClass('header_bar');
    $('.index .header .logo img').attr('src', $('.logo img').data('src-home'));
  } else {
    $(".index .header").addClass('header_bar');
    $('.index .header .logo img').attr('src', $('.logo img').data('src'));
  }

  $('#search-pop').fadeToggle('fast').find('input').focus();
  e.stopPropagation();
  e.preventDefault();
});


// QTY Adjust

/* JS Quantity Incrementers */
jQuery(function(){
  var j = jQuery; 
  var addInput = '.js-qty-wrap'; 

  j(addInput).each(function() { 
    var inputEl = j(this).closest(addInput).find('input');
    var n = inputEl.val(); 
    var plusEl = j(this).closest(addInput).find('.plus');
    var minEl = j(this).closest(addInput).find('.min');
    //On plus click add 1 to n
    plusEl.on('click', function(){
      inputEl.val(++n);
    });
    //On min click 
    minEl.on('click', function(){
    //If n is bigger or equal to 1 subtract 1 from n 
      if ( ( inputEl.val() ) >= 1) {
        inputEl.val(--n);
      } 
    });
  });
});
	

// Product Carousel
$(document).ready(function(){
	var prodCarousel = $(".js-product-carousel");
	prodCarousel.each(function() {        
    $(this).slick({
    slidesToShow: 4,
    slidesToScroll: 4,
  	arrows:true,
  	appendArrows: '.js-product-carousel-buttons',
  	prevArrow: "<button class='carousel-arrow  previous-arrow'><i class='carousel-arrow-icon'></i></button>",
  	nextArrow: "<button class='carousel-arrow next-arrow'><i class='carousel-arrow-icon'></i></button>",
	responsive: [     
  {
      breakpoint: 1024,
      settings: {
       	slidesToShow: 2,
   		slidesToScroll: 2,
      }
    },
        {
      breakpoint: 768,
      settings: {
       	slidesToShow: 2,
   		slidesToScroll: 2,
        arrows:true,
        appendArrows: '.js-product-carousel-buttons',
      }
    },
    {
      breakpoint: 600,
        centerMode: true,
		centerPadding: '60px',
      	settings: {
        slidesToShow: 1,
		slidesToScroll: 1,
		dots:false,
		arrows:true,
		appendArrows: '.js-product-carousel-buttons',

      }
    }
  ]  	
                                 
   });
  }); 
});


// AWARDS Carousel
$(document).ready(function(){
	var awardCarousel = $(".js-awards-carousel");
	awardCarousel.each(function() {        
    $(this).slick({
    slidesToShow: 3,
    slidesToScroll: 3,
  	arrows:true,
  	appendArrows: '.js-awards-carousel-buttons',
  	prevArrow: "<button class='carousel-arrow  previous-arrow'><i class='carousel-arrow-icon'></i></button>",
  	nextArrow: "<button class='carousel-arrow next-arrow'><i class='carousel-arrow-icon'></i></button>",
	responsive: [     
  {
      breakpoint: 1024,
      settings: {
       	slidesToShow: 3,
   		slidesToScroll: 2,
      }
    },
        {
      breakpoint: 768,
      settings: {
       	slidesToShow: 2,
   		slidesToScroll: 2,
        arrows:true,
        appendArrows: '.js-awards-carousel-buttons',
      }
    },
    {
      breakpoint: 600,
        centerMode: true,
		centerPadding: '60px',
      	settings: {
        slidesToShow: 1,
		slidesToScroll: 1,
		dots:false,
		arrows:true,
        appendArrows: '.js-awards-carousel-buttons-mob',

      }
    }
  ]  	
                                 
   });
  }); 
});



// Testimonials Carousel
$(document).ready(function(){
	var myCarousel = $(".js-reviews-carousel");
	myCarousel.each(function() {        
    $(this).slick({
    slidesToShow: 2,
    slidesToScroll: 2,
      infinite: true,
  	arrows:true,
  	appendArrows: '.js-reviews-carousel-buttons',
  	prevArrow: "<button class='carousel-arrow  previous-arrow'><i class='carousel-arrow-icon'></i></button>",
  	nextArrow: "<button class='carousel-arrow next-arrow'><i class='carousel-arrow-icon'></i></button>",
	responsive: [     
  {
      breakpoint: 1024,
      settings: {
       	slidesToShow: 2,
   		slidesToScroll: 2,
      }
    },
        {
      breakpoint: 768,
      settings: {
       	slidesToShow: 2,
   		slidesToScroll: 2,
        arrows:true,
        appendArrows: '.js-reviews-carousel-buttons',
      }
    },
    {
      breakpoint: 600,
        centerMode: true,
		centerPadding: '60px',
      	settings: {
        slidesToShow: 1,
		slidesToScroll: 1,
		dots:false,
		arrows:true,
        appendArrows: '.js-reviews-carousel-buttons-mob',

      }
    }
  ]  	
                                 
   });
  }); 
});



// Blog Carousel
$(document).ready(function(){
	var blogCarousel = $(".js-blog-carousel");
	blogCarousel.each(function() {        
    $(this).slick({
    slidesToShow: 3,
    slidesToScroll: 3,
  	arrows:true,
  	appendArrows: '.js-blog-carousel-buttons',
  	prevArrow: "<button class='carousel-arrow  previous-arrow'><i class='carousel-arrow-icon'></i></button>",
  	nextArrow: "<button class='carousel-arrow next-arrow'><i class='carousel-arrow-icon'></i></button>",
	responsive: [     
  {
      breakpoint: 1024,
      settings: {
       	slidesToShow: 2,
   		slidesToScroll: 2,
      }
    },
        {
      breakpoint: 768,
      settings: {
       	slidesToShow: 2,
   		slidesToScroll: 2,
        arrows:true,
        appendArrows: '.js-blog-carousel-buttons',
      }
    },
    {
      breakpoint: 600,
        centerMode: true,
		centerPadding: '60px',
      	settings: {
        slidesToShow: 1,
		slidesToScroll: 1,
		dots:false,
		arrows:true,
        appendArrows: '.js-blog-carousel-buttons',

      }
    }
  ]  	
                                 
   });
  }); 
});


// Hero Carousel
$(document).ready(function(){
	var myHeroCarousel = $(".js-hero-carousel-slides");
	myHeroCarousel.each(function() {        
    $(this).slick({
    slidesToShow: 1,
    slidesToScroll: 1,
  	arrows:false,
    dots:true,
    appendDots:".dots-container"
   });
  }); 
});




 

// PDP CAROUSEL WITH THUMBS
$('.js-slider-primary').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  infinite:true,
  asNavFor: '.js-slider-thumbs'
});


$('.js-slider-thumbs').slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  asNavFor: '.js-slider-primary',
  dots: false,
  centerMode: false,
  focusOnSelect: true,
  infinite:true,
  vertical: true,
  variableWidth: false,
  arrows: true,
  prevArrow: "<a href='#' class='previous-arrow thumbs-arrow'><i class='thumbs-arrow-icon thumbs-arrow-prev'></i></a>",
  nextArrow: "<a href='#' class='next-arrow thumbs-arrow'><i class='thumbs-arrow-icon thumbs-arrow-next'></i></a>",
  	responsive: [     
    {
      breakpoint: 1024,
      settings: {
        vertical: true
      }
    },
    {
      breakpoint: 768,
      settings: {
        vertical: true,
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 600,
      settings: {
        vertical: false,
        slidesToShow: 3,
        slidesToScroll: 1
      }
    }
    
  ]  
});


// CHANGE IMAGE WITH VARIANT CHANGE
(function(window, $) {
  $(document).ready(function() { 
    $('body')
    .on('change', '#productSelect', function(event) { 
      /** Update image Slider */
      var selected     = this.options[this.selectedIndex]
      var variantImage = selected.dataset.image;
      var position = -1;

      $('.product-thumbs .single-thumb').each(function() { 
        if ( $(this).data('image') == variantImage ) { 
          if ( $(this).hasClass('slick-slide') ) { 
            position = parseInt($(this).data('slick-index'));
          } else {
            position = parseInt($(this).closest('.slick-slide').data('slick-index'));
          }

          return;
        }
      });

      if ( position != -1 ) { 
        $('.product-thumbs').find('.js-slider-thumbs').slick('slickGoTo', position);
      }
    })
  })
})(window, jQuery);


// Footer Nav

function resizeHandler() {
  if ($(window).width() < 767) {
    $('.footer-nav ul').hide();
    $('.footer-nav ul').slideUp(200);
  } else {
    $('.footer-nav ul').show();
    $('.footer-nav-header').removeClass("expanded");
  }

  if ($(window).width() < 1024) {
    $('.blog-nav-list').hide();
    $('.filter-nav-list').slideUp(200);
  } else {
    $('.filter-nav-list').show();
    $('.filter-header').removeClass("expanded");
  }
}

resizeHandler();

$(window).resize(resizeHandler);

$('body').on('click', '.footer-nav-header', function() { 
  if ($(window).width() < 767) {
    $(this).next().slideToggle(200);
    $(this).toggleClass("expanded");
  }
});

$('body').on('click', '.filter-header', function() { 
  if ($(window).width() < 1024) {
    $(this).next().slideToggle(200);
    $(this).toggleClass("expanded");
  }
});



// SELECT STYLES
/*
Reference: http://jsfiddle.net/BB3JK/47/


$('.product-dropdown select').each(function(){
    var $this = $(this), numberOfOptions = $(this).children('option').length;
  
    $this.addClass('select-hidden'); 
    $this.wrap('<div class="select"></div>');
    $this.after('<div class="select-styled"></div>');

    var $styledSelect = $this.next('div.select-styled');
    $styledSelect.text($this.children('option').eq(0).text());
  
    var $list = $('<ul />', {
        'class': 'select-options'
    }).insertAfter($styledSelect);
  
    for (var i = 0; i < numberOfOptions; i++) {
        $('<li />', {
            text: $this.children('option').eq(i).text(),
            rel: $this.children('option').eq(i).val()
        }).appendTo($list);
        //if ($this.children('option').eq(i).is(':selected')){
        //  $('li[rel="' + $this.children('option').eq(i).val() + '"]').addClass('is-selected')
        //}
    }
  
    var $listItems = $list.children('li');
  
    $styledSelect.click(function(e) {
        e.stopPropagation();
        $('div.select-styled.active').not(this).each(function(){
            $(this).removeClass('active').next('ul.select-options').hide();
        });
        $(this).toggleClass('active').next('ul.select-options').toggle();
    });
  
    $listItems.click(function(e) {
        e.stopPropagation();
        $styledSelect.text($(this).text()).removeClass('active');
        $this.val($(this).attr('rel'));
        $list.hide();
        //console.log($this.val());
    });
  
    $(document).click(function() {
        $styledSelect.removeClass('active');
        $list.hide();
    });

});
*/

/** ReCharge Price Change */
(() => {
  if ( ! $('#singleProduct').length || $('#singleProduct .pdp-single #productSelect option').length < 2 ) {
    return
  }

  const wrapper = $('#singleProduct')
  const variantSelector = wrapper.find('.pdp-single #productSelect')

  let isReChargeInited = false
  let oldProductPrice = wrapper.find('.pdp-single .single-pdp-price .price').text().trim()
  let rcInitInterval = null

  const checkReChargeInit = () => {
    const rcWrapper = $('#rc_container')
    if ( rcWrapper.css('display') == 'block' ) {
      isReChargeInited = true

      clearInterval(rcInitInterval)

      // Check Price
      updateOptionPrice()
    }
  }

  const updateOptionPrice = () => {
    const newProductPrice = wrapper.find('.pdp-single .single-pdp-price .price').text().trim()

    if ( newProductPrice != oldProductPrice ) {
      oldProductPrice = newProductPrice
      const selectedVariant = variantSelector.find('option:selected')

      selectedVariant.text(selectedVariant.attr('data-title') + ` - ` + newProductPrice)
    }
  }

  rcInitInterval = setInterval(checkReChargeInit, 500)

  $('body')
  .on('change', '#productSelect', (event) => { 
    setTimeout(updateOptionPrice, 50)
  })
  .on(`change`, `#rc_container [name="purchase_type"]`, (event) => {
    setTimeout(updateOptionPrice, 50)
  })
})()

/* holiday component banner class BannerTimed extends HTMLElement {
  constructor() {
    super();
    const shadow = this.attachShadow({ mode: 'open' });
    this.shadowRoot.innerHTML=`
    <style>
      .date-banner {
        background: #f9a054;
        position: sticky;
        top: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: 900;
        font-family: sans-serif;
        z-index: 99
      }
      
      .date-banner slot {
        color: #2151a3;
        display: block;
        text-align:center;
        padding: 12px 20px;
        font-family: sans-serif;
      }
    </style>
      <div class="date-banner">
        <div class="banner">
          <slot></slot>
        </div>
      </div>
    `

    this.checkDate();
  }

  checkDate() {
    const banner = this.shadowRoot.querySelector('.date-banner');
    const startDate = this.getAttribute('start-date');
    const endDate = this.getAttribute('end-date');
    const today = this.getAttribute('now-date');
    const message = this.shadowRoot.querySelector('.date-banner slot');
    message.textContent = this.getAttribute('message');

    if(startDate < today && today < endDate) {
      banner.style.display='block'
    }else {
      this.removeAttribute('start-date');
      this.removeAttribute('end-date');
      banner.style.display='none'
    }
  }

}

customElements.define('banner-timed', BannerTimed);*/
